import { render, staticRenderFns } from "./verticalAlignBottom.vue?vue&type=template&id=b9a6ae1c&"
import script from "./verticalAlignBottom.vue?vue&type=script&lang=ts&"
export * from "./verticalAlignBottom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports